import { AutoMetricApi, YaMetricsCounter, YaMetricsPublisher } from '@beef/auto-metric';
import { getAccountType } from "./auth";
export var yaMetricCounter = new YaMetricsCounter(26001372);
export var yaMetricsPublisher = new YaMetricsPublisher(yaMetricCounter);
export var lowCodeMetricApi = new AutoMetricApi([yaMetricsPublisher]);
var generateLPName = function generateLPName() {
  var path = window.location.pathname.split('/');
  // eslint-disable-next-line sonarjs/no-identical-expressions
  return "LP_/".concat(path.pop() || path.pop());
};

// todo: typing
export var getLowCodePageMetrics = function getLowCodePageMetrics(headerStore2024) {
  return function () {
    var _headerStore, _headerStore$getState, _headerStore$getState2, _headerStore$getState3, _headerStore$getState4;
    return {
      name: generateLPName(),
      url: window.location.href,
      path: window.location.pathname,
      title: document.title,
      account_type: getAccountType((_headerStore = headerStore2024()) === null || _headerStore === void 0 ? void 0 : (_headerStore$getState = _headerStore.getState()) === null || _headerStore$getState === void 0 ? void 0 : (_headerStore$getState2 = _headerStore$getState.header) === null || _headerStore$getState2 === void 0 ? void 0 : (_headerStore$getState3 = _headerStore$getState2.common) === null || _headerStore$getState3 === void 0 ? void 0 : (_headerStore$getState4 = _headerStore$getState3.auth) === null || _headerStore$getState4 === void 0 ? void 0 : _headerStore$getState4.user)
    };
  };
};